import { useFormikContext } from 'formik';
import { cn } from 'utils/helpers';

import { EVENT_FORM } from '../schema';

const AddTitle = () => {
  const { values, handleChange, handleBlur, errors, touched } =
    useFormikContext<EVENT_FORM>();

  return (
    <div className="border-b-[0.5px] border-b-card-secondary pb-3">
      <input
        value={values.title}
        name="title"
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="Add Title"
        className={cn(
          'w-full text-sm',
          'border-0 outline-none',
          'placeholder-normal placeholder-secondary',
          'font-semibold',
        )}
      />
      {errors?.title && touched?.title && (
        <p className="text-danger-base text-sm">{errors.title}</p>
      )}
    </div>
  );
};

export default AddTitle;
